/**
 * BrewNectar Compounding Effect — scroll-triggered fade-up animations
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initSection(section) {
    if (!section || section.dataset.bnCeInit === 'true') return;
    section.dataset.bnCeInit = 'true';

    var animated = section.querySelectorAll('.bn-ce__animate');

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var rootMargin = section.getAttribute('data-bn-ce-observer-margin') || '-60px 0px';

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: rootMargin, threshold: 0 }
    );

    animated.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-bn-ce-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-bn-ce-section]') || e.target;
    if (section.matches && section.matches('[data-bn-ce-section]')) {
      section.dataset.bnCeInit = '';
      initSection(section);
    }
  });
})();
